import React from 'react';
import styled, { css } from 'styled-components';

const Container = styled.div`
  margin: 0 0 1.5rem;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    margin: ${theme.form.row.margin || '0 0 1.5rem'};
  `}
`;

export const FormRow = (props) => <Container {...props} />;

export default FormRow;

